import { numericUtil } from '@cmg/common';

import { ParticipationGridColDef, ParticipationRecordItem } from '../../types';

export type Value = ParticipationRecordItem['indicationNotionalUsd'];

export const indicationUsdColDef: ParticipationGridColDef<Value> = {
  field: 'indicationNotionalUsd',
  headerName: 'Indication $',
  type: ['numericColumn', 'number'],
  filter: 'agNumberColumnFilter',
  aggFunc: 'sum',
  floatingFilter: true,
  valueFormatter: ({ value }) => numericUtil.getDisplayValueForCurrency(value),
};

// csv header to field name mapping for upload participation set
export const indicationNotionalUsdHeaderMapping = {
  fieldName: 'indicationNotionalUsd',
  displayName: 'Indication $',
  acceptedHeaders: ['Indication $', 'Indication ($)', 'Indication (USD)', 'Demand $'],
};
